module.exports = __webpack_public_path__ + "img/owl2.19006295.png";